import React from "react";
import DashboardPage from "./DashboardPage";
import withScrollOnLeave from "../../../withScrollOnLeave";

const DashboardContainer = () => <DashboardPage />;

DashboardContainer.propTypes = {};

export default withScrollOnLeave(DashboardContainer);
